import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=2699dcfa&"
import script from "./ButtonBar.vue?vue&type=script&lang=js&"
export * from "./ButtonBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2699dcfa')) {
      api.createRecord('2699dcfa', component.options)
    } else {
      api.reload('2699dcfa', component.options)
    }
    module.hot.accept("./ButtonBar.vue?vue&type=template&id=2699dcfa&", function () {
      api.rerender('2699dcfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/channels/ButtonBar.vue"
export default component.exports